import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '@backstage/core-plugin-api';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import { EmbeddableWorkflow } from '@backstage/plugin-scaffolder-react/alpha';
import { JsonValue } from '@backstage/types';

// @ts-ignore
import { defaultExtensions } from './extensions';

interface TemplateWizardProps {
  templateRef: string;
}

export const TemplateWizard = ({ templateRef }: TemplateWizardProps) => {
  const scaffolderApi = useApi(scaffolderApiRef);
  const navigate = useNavigate();

  const onCreate = useCallback(
    async (values: Record<string, JsonValue>) => {
      const { taskId } = await scaffolderApi.scaffold({
        templateRef,
        values,
      });

      navigate(`/create/tasks/${taskId}`);
    },
    [scaffolderApi, templateRef, navigate],
  );

  const onError = useCallback(
    (error: Error | undefined) => {
      return <div>Error loading template: {error?.message}</div>;
    },
    [],
  );

  // Parse templateRef to get namespace and templateName
  // Assuming templateRef is like "namespace/name" or just "name" (implies default)
  let namespace = 'default';
  let templateName = templateRef;

  if (templateRef.includes('/')) {
    const parts = templateRef.split('/');
    if (parts.length >= 2) {
      namespace = parts[parts.length - 2];
      templateName = parts[parts.length - 1];
    }
  }

  return (
    <EmbeddableWorkflow
      namespace={namespace}
      templateName={templateName}
      onCreate={onCreate}
      onError={onError}
      extensions={defaultExtensions}
    />
  );
};

